/*eslint-disable */
var $ = window.jQuery = require('jquery');

import {mapGetters, mapState} from 'vuex';

import store from '@/store/store';

export default {
  name: 'usersidebar',
  components: {},
  props: [],
  data () {
    return {
      categoryList: {},
      userSubscription: Boolean,
      collapseIconState:false
    }
  },
  computed: {
  },
  mounted () {
    this.getCategory,
    $(document).ready(function(){
      $('.toggleSidebar').on('click', function(){
        if($(window).width() < 981){
          $('#sidebarToggle, #sidebarToggleRight, .user-dashboard, body').removeClass('show');
          $('header .mobilemenu-icon').removeClass('open');
        }
      })
    }) 
   
  },
  methods: {
    toggleSide(){
      if($(window).width() < 981){
        $('#sidebarToggle, #sidebarToggleRight, .user-dashboard, body').removeClass('show');
        $('header .mobilemenu-icon').removeClass('open');
      }
    },
    sideCollaspeMethod(){
      if(this.collapseIconState == true){
        document.querySelector('.user-dashboard').classList.remove('actvCollaspe');
        this.collapseIconState = false
      }else{
        this.collapseIconState = true
        document.querySelector('.user-dashboard').classList.add('actvCollaspe');
      }
    }
  },
}